<template>
    <div class="col-lg-6 col-sm-12">
        <div class="employee-box">
            <div class="image">
                <img v-if="image" :src="image" />
                <img v-else src="/static/images/avatar.jpg" />
            </div>
            <div class="info">
                <div class="name">
                    {{ name }}
                </div>
                <div class="position">
                    {{ position }}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.employee-box {
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, .07);
    box-shadow: 0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07);
    height: 120px;

    &:not(:last-of-type) {
        margin-bottom: 20px;
    }

    &:last-of-type {
        margin-bottom: 30px;
    }

    .image {
        margin-right: 20px;
        max-width: 80px;

        img {
            width: 100%;
            border-radius: 100px;
        }
    }

    .info {

        .name {
            font-weight: bold;
        }
    }
}
</style>

<script>
export default {
    props: {
        name: {
            required: true,
            type: String
        },
        position: {
            required: true,
            type: String
        },
        image: {
            required: false,
            type: String
        }
    }
}
</script>



// WEBPACK FOOTER //
// employee.vue?7e9fdb34